export default __webpack_public_path__ + "static/aikido-dummy-25db4a292e192d2892b7224392b462df.jpg";